/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState, useMemo, useCallback } from 'react';

import DateFnsUtils from '@date-io/date-fns';
import { CircularProgress, Snackbar, TextField,
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from '@material-ui/pickers';
import axios from 'axios';
import moment from 'moment';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import PageTitleAndFilter from 'components/PageTitleAndFilter';
import TitleHead from 'components/TitleHead';
import Layout from 'containers/layouts/layout';
import PlayIcon from 'images/icons/signals/playsAndStarts/playCountMobileIcon.svg';
import * as UserActions from 'store/actions/user';
import { Container, GlobalStyle } from 'styles/general';
import Environment from 'utils/environments';

const environments = Environment(process.env.REACT_APP_ENV);

function BackOffice({ userInfo }) {
  const actualDate = new Date();
  const actualDateLessOne = new Date(
    new Date().setDate(new Date().getDate() - 1)
  );
  const actualDateLessTwo = new Date(
    new Date().setDate(new Date().getDate() - 2)
  );
  const actualDatePlusOne = new Date(
    new Date().setDate(new Date().getDate() + 1)
  );

  const { id: paramsID } = useParams();

  const callSettings = useMemo(
    () => ({
      getId: paramsID,
      page: 1,
      totalPages: 0,
      size: 100
    }),
    [paramsID]
  );

  const { getId } = callSettings;

  const [closureInfos, setClosureInfos] = useState();
  const [countManuallyInfos, setCountManuallyInfos] = useState();
  const [salesInfos, setSalesInfos] = useState();
  const [photoStockInfos, setPhotoStockInfos] = useState()
  const [cmvViewInfos, setCmvViewInfos] = useState()
  const [orderInfos, setOrderInfos] = useState()
  const [costInfos, setCostInfos] = useState()
  const [salesStrutureInfos, setSalesStrutureInfos] = useState()
  const [salesMenuInfos, setSalesMenuInfos] = useState()
  const [cmvStrutureMenuInfos, setCmvStrutureMenuInfos] = useState()
  const [cmvProductInfos, setCmvProductInfos] = useState({sucessReq: false, products: []})
  const [clearSalesInfos, setClearSalesInfos] = useState()

  const [initialDate, setInitialDate] = useState(actualDate)
  const [endDate, setEndDate] = useState(actualDate)
  const [stockRestId, setStockRestId] = useState('')

  const [daysCmv, setDaysCmv] = useState()
  const [cmvRestIds, setCmvRestIds] = useState()

  const [numberOrder, setNumberOrder] = useState()
  const [orderRestId, setOrderRestId] = useState()

  const [costDate, setCostDate] = useState()
  const [costRestId, setCostRestId] = useState()

  const [salesStrutureRestId, setSalesStrutureRestId] = useState()

  const [salesMenuDate, setSalesMenuDate] = useState()
  const [salesMenuRestId, setSalesMenuRestId] = useState()

  const [cmvStrutureId, setCmvStrutureId] = useState()

  const [cmvProductDate, setCmvProductDate] = useState()
  const [cmvProductId, setCmvProductId] = useState()

  const [clearSalesDate, setClearSalesDate] = useState()
  const [clearSalesId, setClearSalesId] = useState()

  const [loadingObj, setLoadingObj] = useState({
    closure: false,
    countManually: false,
    sales: false,
    photoStock: false,
    cmvView: false,
    order: false,
    cost: false,
    salesStruture: false,
    salesMenu: false,
    cmvStruture: false,
    cmvProducts: false,
    clearSales: false
  });

  const [message, setMessage] = useState({
    description: '',
    status: ''
  });

  const getClosureInfos = useCallback(() => {
    setLoadingObj({ ...loadingObj, closure: true });
    const initialDateFormatted = moment(actualDateLessTwo).format('YYYY-MM-DD');
    const finalDateFormatted = moment(actualDateLessOne).format('YYYY-MM-DD');

    axios
      .get(
        `${environments.catalog}/inventories/internal/manuallyDailyStock?startDate=${initialDateFormatted}&finishDate=${finalDateFormatted}&restaurantId=${getId}`
      )
      .then((response) => {
        setClosureInfos(response?.data || {});
        setLoadingObj({ ...loadingObj, closure: false });
      })
      .catch((error) => {
        setClosureInfos({});
        setLoadingObj({ ...loadingObj, closure: false });
        console.log(error);
      });
  }, [userInfo.companiesActive.id]);

  const getCountManuallyInfos = useCallback(() => {
    setLoadingObj({ ...loadingObj, countManually: true });

    const initialDateFormatted = moment(actualDate).format('YYYY-MM-DD');
    const finalDateFormatted = moment(actualDatePlusOne).format('YYYY-MM-DD');

    axios
      .get(
        `${environments.worker}/config/openManuallyCount?initialDate=${initialDateFormatted}&finalDate=${finalDateFormatted}&restaurantId=${getId}`
      )
      .then((response) => {
        setCountManuallyInfos(response?.data || {});
        setLoadingObj({ ...loadingObj, countManually: false });
      })
      .catch((error) => {
        setCountManuallyInfos({});
        setLoadingObj({ ...loadingObj, countManually: false });

        console.log(error);
      });
  }, [userInfo.companiesActive.id]);

  const getSalesInfos = useCallback(() => {
    setLoadingObj({ ...loadingObj, sales: true });

    const body = {
      restaurantId: getId
    };

    axios
      .post(`${environments.sales}/sales/reprocess`, body)
      .then((response) => {
        setSalesInfos(response?.data || {});
        setLoadingObj({ ...loadingObj, sales: false });
      })
      .catch((error) => {
        setSalesInfos({});
        setLoadingObj({ ...loadingObj, sales: false });

        console.log(error);
      });
  }, [userInfo.companiesActive.id]);
  

  const stockInfo = () => {
    const initialDateFormatted = moment(initialDate).format('YYYY-MM-DD');
    const finalDateFormatted = moment(endDate).format('YYYY-MM-DD');

    axios.get(`${environments.catalog}/inventories/internal/manuallyDailyStock?restaurantId=${stockRestId}&startDate=${initialDateFormatted}&finishDate=${finalDateFormatted}`)
      .then((response) => {
        setPhotoStockInfos(response?.data || {})
        setLoadingObj({ ...loadingObj, photoStock: false });
    })
    .catch((error) => {
      setPhotoStockInfos({});
      setLoadingObj({ ...loadingObj, photoStock: false });

      console.log(error);
    });
  }

  const cmvView = () => {
    const body ={
      days: daysCmv,
      restaurantIds: [
        cmvRestIds
      ]
    }

    axios.post(`${environments.dashBoard}/cmvView`, body)
      .then((response) => {
        setCmvViewInfos(response.data)
        setLoadingObj({ ...loadingObj, cmvView: false });
      })
      .catch((error) => {
        setCmvViewInfos({});
        setLoadingObj({ ...loadingObj, cmvView: false });
  
        console.log(error);
      });
  }

  const orderReq = () => {
    axios.get(`${environments.orders}/orders/fix?numberOfDays=1&restaurantId=${orderRestId}&processNow=true&orderIds=${numberOrder}`)
      .then((response) => {
        setOrderInfos(response.data)
        setLoadingObj({ ...loadingObj, order: false });
      })
      .catch((error) => {
        setCmvViewInfos({});
        setLoadingObj({ ...loadingObj, order: false });
  
        console.log(error);
      });
  }

  const costReq = () => {
    const dateFormatted = moment(costDate).format('YYYY-MM-DD');

    axios.get(`${environments.worker}/config/costs?restaurantId=${costRestId}&date=${dateFormatted}`)
      .then((response) => {
        setCostInfos(response.data)
        setLoadingObj({ ...loadingObj, cost: false });
      })
      .catch((error) => {
        setCostInfos({});
        setLoadingObj({ ...loadingObj, cost: false });
  
        console.log(error);
      });
  }

  const salesStruture = () => {
    const body = {
      restaurantId: [
        salesStrutureRestId
      ]
    }
    axios.post(`${environments.worker}/config/cardsItems`, body)
      .then((response) => {
        setSalesStrutureInfos(response.data)
        setLoadingObj({ ...loadingObj, salesStruture: false });
      })
      .catch((error) => {
        setSalesStrutureInfos({});
        setLoadingObj({ ...loadingObj, salesStruture: false });
  
        console.log(error);
      });
  }

  const salesMenu = () => {
    const dateFormatted = moment(salesMenuDate).format('YYYY-MM-DD');

    const body = {
      restaurantId: [
        salesMenuRestId
      ],
      date: dateFormatted
    }
    axios.post(`${environments.sales}/sales/reprocess`, body)
      .then((response) => {
        setSalesMenuInfos(response.data)
        setLoadingObj({ ...loadingObj, salesMenu: false });
      })
      .catch((error) => {
        setSalesMenuInfos({});
        setLoadingObj({ ...loadingObj, salesMenu: false });
  
        console.log(error);
      });
  }

  const cmvStruture = () => {
    const body = {
      restaurantId: [
        salesStrutureRestId
      ]
    }
    axios.post(`${environments.worker}/config/menuProducts`, body)
      .then((response) => {
        setCmvStrutureMenuInfos(response.data)
        setLoadingObj({ ...loadingObj, cmvStruture: false });
      })
      .catch((error) => {
        setCmvStrutureMenuInfos({});
        setLoadingObj({ ...loadingObj, cmvStruture: false });
  
        console.log(error);
      });
  }

  const cmvProductReq = () => {
    const dateFormatted = moment(cmvProductDate).format('YYYY-MM-DD');

    axios.get(`${environments.dashBoard}/cmvView/day?restaurantId=${cmvProductId}&startDate=${dateFormatted}&endDate=${dateFormatted}`)
      .then((response) => {
        setCmvProductInfos({...cmvProductInfos, sucessReq: true, products: response.data})
        setLoadingObj({ ...loadingObj, cmvProduct: false });
      })
      .catch((error) => {
        setCmvProductInfos({...cmvProductInfos, sucessReq: false});
        setLoadingObj({ ...loadingObj, cmvProducts: false });
  
        console.log(error);
      });
  }

  const clearSales = () => {
    const dateFormatted = moment(clearSalesDate).format('YYYY-MM-DD');

    const body = {
      restaurantId: [
        salesMenuRestId
      ],
      date: dateFormatted
    }
    axios.post(`${environments.sales}/sales/clear`, body)
      .then((response) => {
        setClearSalesInfos(response.data)
        setLoadingObj({ ...loadingObj, clearSales: false });
      })
      .catch((error) => {
        setClearSalesInfos({});
        setLoadingObj({ ...loadingObj, clearSales: false });
  
        console.log(error);
      });
  }

  return (
    <Layout>
      <TitleHead title="Back Office" />

      <GlobalStyle />

      <Container className="closureAndSuggestionsPage">
        <PageTitleAndFilter title="Back Office" />

        <section className="dFlex flexColumn">
          <div className="cardBlueTitleDefault closureCard">
            <div className='bold cardHeader'>
              <p>Foto Estoque</p>
            </div>
            <div className="cardContent flexColumn dFlex">
              <div className="mb10 justifyBetween">
                  <div className='mt20'>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <div className='dFlex'>
                        <div>
                          <KeyboardDatePicker
                            size="small"
                            id="time-picker"
                            label="Data Inicio"
                            ampm={false}
                            clearable
                            format="dd/MM/yyyy"
                            value={initialDate}
                            inputVariant="outlined"
                            className="dateSmall mt20 mr10"
                            style={{width: '100px'}}
                            placeholder='DD-MM-AAAA'
                            autoOk
                            InputProps={{
                              style: { fontFamily: 'Lato', fontSize: '12px' }
                            }}
                            onChange={(date) => {
                              setInitialDate(date)
                            }}
                            KeyboardButtonProps={{
                              'aria-label': 'change time'
                            }}
                          />
                        </div>
                        <div>
                          <KeyboardDatePicker
                            size="small"
                            id="time-picker"
                            label="Data Fim"
                            ampm={false}
                            clearable
                            format="dd/MM/yyyy"
                            value={endDate}
                            inputVariant="outlined"
                            className="dateSmall mt20 mr10"
                            style={{width: '100px'}}
                            placeholder='DD-MM-AAAA'
                            autoOk
                            InputProps={{
                              style: { fontFamily: 'Lato', fontSize: '12px' }
                            }}
                            onChange={(date) => {
                              setEndDate(date)
                            }}
                            KeyboardButtonProps={{
                              'aria-label': 'change time'
                            }}
                          />
                        </div>
                        <div className='dFlex'>
                        <div className='dFlex flexColumn justifyEnd'>
                          <label className='bold mb2' style={{fontSize: '12px'}}>Id do restaurante</label>
                            <TextField
                              size="small"
                              onChange={(e) => setStockRestId(e.target.value)}
                              variant="outlined"
                              value={stockRestId}
                              fullWidth
                              required="required"
                              onInput={(e) => {
                                e.target.value = e.target.value.replace(/[^0-9]/g, '');
                              }}
                              inputProps={{ maxLength: 2 }}
                              style={{ width: 70 }}
                              className="textFieldSmall p0"
                              placeholder="Id"
                              InputLabelProps={{
                                shrink: true
                              }}
                            />
                        </div>
                        <div className="dFlex alignEnd" onClick={() => stockInfo()}>
                          <img
                            src={PlayIcon}
                            alt="playIcon"
                            className="mr10 cursorPointer"
                            style={{ width: 20 }}
                          />

                          {loadingObj.photoStock ? (
                              <CircularProgress size={20} />
                            ) : (
                              <span
                                className={photoStockInfos && 'bold'}
                                style={{
                                  color: photoStockInfos ? '#08AA15' : '#0F1225'
                                }}
                              >
                                {photoStockInfos ? 'OK' : ''}
                              </span>
                            )}
                        </div>
                      </div>
                      </div>
                    </MuiPickersUtilsProvider>
                  </div>
                </div>
              </div>

              <div className="cardHeader">
                <p>Foto Cmv</p>
              </div>
              <div className='cardContent'>
                  <div className="dFlex mb10">
                    <div className='dFlex mt10 flexColumn'>
                      <label className='bold mb0' style={{fontSize: '12px'}}>Dias</label>
                      <TextField
                        size="small"
                        onChange={(e) => setDaysCmv(e.target.value)}
                        variant="outlined"
                        value={daysCmv}
                        fullWidth
                        required="required"
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(/[^0-9]/g, '');
                        }}
                        inputProps={{ maxLength: 2 }}
                        style={{ width: 70 }}
                        className="textFieldSmall p0 mr10"
                        placeholder="0"
                        InputLabelProps={{
                          shrink: true
                        }}
                      />
                    </div>
                    <div className='dFlex mt10 flexColumn'>
                      <label className='bold mb0' style={{fontSize: '12px'}}>Id do restaurante</label>
                      <TextField
                        size="small"
                        onChange={(e) => setCmvRestIds(e.target.value)}
                        variant="outlined"
                        value={cmvRestIds}
                        fullWidth
                        required="required"
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(/[^0-9]/g, '');
                        }}
                        inputProps={{ maxLength: 2 }}
                        style={{ width: 70 }}
                        className="textFieldSmall p0"
                        placeholder="Id"
                        InputLabelProps={{
                          shrink: true
                        }}
                      />
                    </div>
                    <div className="dFlex alignEnd" onClick={() => cmvView()}>
                      <img
                        src={PlayIcon}
                        alt="playIcon"
                        className="mr10 cursorPointer"
                        style={{ width: 20 }}
                      />

                      {loadingObj.cmvView ? (
                          <CircularProgress size={20} />
                        ) : (
                          <span
                            className={cmvViewInfos && 'bold'}
                            style={{
                              color: cmvViewInfos ? '#08AA15' : '#0F1225'
                            }}
                          >
                            {cmvViewInfos ? 'OK' : ''}
                          </span>
                        )}
                    </div>
                  </div>
              </div>

              <div className="cardHeader">
                <p>Pedido</p>
              </div>
              <div className='cardContent'>
                  <div className="dFlex mb10">
                    <div className='dFlex mt10 flexColumn'>
                      <label className='bold mb0' style={{fontSize: '12px'}}>N° do Pedido</label>
                      <TextField
                        size="small"
                        onChange={(e) => setNumberOrder(e.target.value)}
                        variant="outlined"
                        value={numberOrder}
                        fullWidth
                        required="required"
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(/[^0-9]/g, '');
                        }}
                        style={{ width: 90 }}
                        className="textFieldSmall p0 mr10"
                        placeholder="0"
                        InputLabelProps={{
                          shrink: true
                        }}
                      />
                    </div>
                    <div className='dFlex mt10 flexColumn'>
                      <label className='bold mb0' style={{fontSize: '12px'}}>Id do restaurante</label>
                      <TextField
                        size="small"
                        onChange={(e) => setOrderRestId(e.target.value)}
                        variant="outlined"
                        value={orderRestId}
                        fullWidth
                        required="required"
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(/[^0-9]/g, '');
                        }}
                        inputProps={{ maxLength: 2 }}
                        style={{ width: 70 }}
                        className="textFieldSmall p0"
                        placeholder="Id"
                        InputLabelProps={{
                          shrink: true
                        }}
                      />
                    </div>
                    <div className="dFlex alignEnd" onClick={() => orderReq()}>
                      <img
                        src={PlayIcon}
                        alt="playIcon"
                        className="mr10 cursorPointer"
                        style={{ width: 20 }}
                      />

                      {loadingObj.order ? (
                          <CircularProgress size={20} />
                        ) : (
                          <span
                            className={orderInfos && 'bold'}
                            style={{
                              color: orderInfos ? '#08AA15' : '#0F1225'
                            }}
                          >
                            {orderInfos ? 'OK' : ''}
                          </span>
                        )}
                    </div>
                  </div>
              </div>

              <div className="cardHeader">
                <p>Custo</p>
              </div>
              <div className='cardContent'>
                  <div className="dFlex mb10">
                    <div className='dFlex mt10 flexColumn'>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        size="small"
                        id="time-picker"
                        label="Data"
                        ampm={false}
                        clearable
                        format="dd/MM/yyyy"
                        value={costDate}
                        inputVariant="outlined"
                        className="dateSmall mt20 mr10"
                        style={{width: '100px'}}
                        placeholder='DD-MM-AAAA'
                        autoOk
                        InputProps={{
                          style: { fontFamily: 'Lato', fontSize: '12px' }
                        }}
                        onChange={(date) => {
                          setCostDate(date)
                        }}
                        KeyboardButtonProps={{
                          'aria-label': 'change time'
                        }}
                      />
                      </MuiPickersUtilsProvider>
                    </div>
                    <div className='dFlex mt10 flexColumn justifyEnd'>
                      <label className='bold mb0' style={{fontSize: '12px'}}>Id do restaurante</label>
                      <TextField
                        size="small"
                        onChange={(e) => setCostRestId(e.target.value)}
                        variant="outlined"
                        value={costRestId}
                        fullWidth
                        required="required"
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(/[^0-9]/g, '');
                        }}
                        inputProps={{ maxLength: 2 }}
                        style={{ width: 70 }}
                        className="textFieldSmall p0"
                        placeholder="Id"
                        InputLabelProps={{
                          shrink: true
                        }}
                      />
                    </div>
                    <div className="dFlex alignEnd" onClick={() => costReq()}>
                      <img
                        src={PlayIcon}
                        alt="playIcon"
                        className="mr10 cursorPointer"
                        style={{ width: 20 }}
                      />

                      {loadingObj.cost ? (
                          <CircularProgress size={20} />
                        ) : (
                          <span
                            className={costInfos && 'bold'}
                            style={{
                              color: costInfos ? '#08AA15' : '#0F1225'
                            }}
                          >
                            {costInfos ? 'OK' : ''}
                          </span>
                        )}
                    </div>
                  </div>
              </div>

              <div className="cardHeader">
                <p>Estrutura de Vendas</p>
              </div>
              <div className='cardContent'>
                  <div className="dFlex mb10">
                    <div className='dFlex mt10 flexColumn'>
                      <label className='bold mb0' style={{fontSize: '12px'}}>Id do restaurante</label>
                      <TextField
                        size="small"
                        onChange={(e) => setSalesStrutureRestId(e.target.value)}
                        variant="outlined"
                        value={salesStrutureRestId}
                        fullWidth
                        required="required"
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(/[^0-9]/g, '');
                        }}
                        inputProps={{ maxLength: 2 }}
                        style={{ width: 70 }}
                        className="textFieldSmall p0"
                        placeholder="Id"
                        InputLabelProps={{
                          shrink: true
                        }}
                      />
                    </div>
                    <div className="dFlex alignEnd" onClick={() => salesStruture()}>
                      <img
                        src={PlayIcon}
                        alt="playIcon"
                        className="mr10 cursorPointer"
                        style={{ width: 20 }}
                      />

                      {loadingObj.salesStruture ? (
                          <CircularProgress size={20} />
                        ) : (
                          <span
                            className={salesStrutureInfos && 'bold'}
                            style={{
                              color: salesStrutureInfos ? '#08AA15' : '#0F1225'
                            }}
                          >
                            {salesStrutureInfos ? 'OK' : ''}
                          </span>
                        )}
                    </div>
                  </div>
              </div>

              <div className="cardHeader">
                <p>Venda no cardápio sem reflexo no produto</p>
              </div>
              <div className='cardContent'>
                  <div className="dFlex mb10">
                    <div className='dFlex mt10 flexColumn'>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        size="small"
                        id="time-picker"
                        label="Data"
                        ampm={false}
                        clearable
                        format="dd/MM/yyyy"
                        value={salesMenuDate}
                        inputVariant="outlined"
                        className="dateSmall mt20 mr10"
                        style={{width: '100px'}}
                        placeholder='DD-MM-AAAA'
                        autoOk
                        InputProps={{
                          style: { fontFamily: 'Lato', fontSize: '12px' }
                        }}
                        onChange={(date) => {
                          setSalesMenuDate(date)
                        }}
                        KeyboardButtonProps={{
                          'aria-label': 'change time'
                        }}
                      />
                      </MuiPickersUtilsProvider>
                    </div>
                    <div className='dFlex mt10 flexColumn justifyEnd'>
                      <label className='bold mb0' style={{fontSize: '12px'}}>Id do restaurante</label>
                      <TextField
                        size="small"
                        onChange={(e) => setSalesMenuRestId(e.target.value)}
                        variant="outlined"
                        value={salesMenuRestId}
                        fullWidth
                        required="required"
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(/[^0-9]/g, '');
                        }}
                        inputProps={{ maxLength: 2 }}
                        style={{ width: 70 }}
                        className="textFieldSmall p0"
                        placeholder="Id"
                        InputLabelProps={{
                          shrink: true
                        }}
                      />
                    </div>
                    <div className="dFlex alignEnd" onClick={() => salesMenu()}>
                      <img
                        src={PlayIcon}
                        alt="playIcon"
                        className="mr10 cursorPointer"
                        style={{ width: 20 }}
                      />

                      {loadingObj.salesMenu ? (
                          <CircularProgress size={20} />
                        ) : (
                          <span
                            className={salesMenuInfos && 'bold'}
                            style={{
                              color: salesMenuInfos ? '#08AA15' : '#0F1225'
                            }}
                          >
                            {salesMenuInfos ? 'OK' : ''}
                          </span>
                        )}
                    </div>
                  </div>
              </div>

              <div className="cardHeader">
                <p>Estrutura do CMV</p>
              </div>
              <div className='cardContent'>
                  <div className="dFlex mb10">
                    <div className='dFlex mt10 flexColumn'>
                      <label className='bold mb0' style={{fontSize: '12px'}}>Id do restaurante</label>
                      <TextField
                        size="small"
                        onChange={(e) => setCmvStrutureId(e.target.value)}
                        variant="outlined"
                        value={cmvStrutureId}
                        fullWidth
                        required="required"
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(/[^0-9]/g, '');
                        }}
                        inputProps={{ maxLength: 2 }}
                        style={{ width: 70 }}
                        className="textFieldSmall p0"
                        placeholder="Id"
                        InputLabelProps={{
                          shrink: true
                        }}
                      />
                    </div>
                    <div className="dFlex alignEnd" onClick={() => cmvStruture()}>
                      <img
                        src={PlayIcon}
                        alt="playIcon"
                        className="mr10 cursorPointer"
                        style={{ width: 20 }}
                      />

                      {loadingObj.cmvStruture ? (
                          <CircularProgress size={20} />
                        ) : (
                          <span
                            className={cmvStrutureMenuInfos && 'bold'}
                            style={{
                              color: cmvStrutureMenuInfos ? '#08AA15' : '#0F1225'
                            }}
                          >
                            {cmvStrutureMenuInfos ? 'OK' : ''}
                          </span>
                        )}
                    </div>
                  </div>
              </div>

              <div className="cardHeader">
                <p>Cmv x Produto errado</p>
              </div>
              <div className='cardContent'>
                  <div className="dFlex mb10">
                    <div className='dFlex mt10 flexColumn'>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        size="small"
                        id="time-picker"
                        label="Data"
                        ampm={false}
                        clearable
                        format="dd/MM/yyyy"
                        value={cmvProductDate}
                        inputVariant="outlined"
                        className="dateSmall mt20 mr10"
                        style={{width: '100px'}}
                        placeholder='DD-MM-AAAA'
                        autoOk
                        InputProps={{
                          style: { fontFamily: 'Lato', fontSize: '12px' }
                        }}
                        onChange={(date) => {
                          setCmvProductDate(date)
                        }}
                        KeyboardButtonProps={{
                          'aria-label': 'change time'
                        }}
                      />
                      </MuiPickersUtilsProvider>
                    </div>
                    <div className='dFlex mt10 flexColumn justifyEnd'>
                      <label className='bold mb0' style={{fontSize: '12px'}}>Id do restaurante</label>
                      <TextField
                        size="small"
                        onChange={(e) => setCmvProductId(e.target.value)}
                        variant="outlined"
                        value={cmvProductId}
                        fullWidth
                        required="required"
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(/[^0-9]/g, '');
                        }}
                        inputProps={{ maxLength: 2 }}
                        style={{ width: 70 }}
                        className="textFieldSmall p0"
                        placeholder="Id"
                        InputLabelProps={{
                          shrink: true
                        }}
                      />
                    </div>
                    <div className="dFlex alignEnd" onClick={() => cmvProductReq()}>
                      <img
                        src={PlayIcon}
                        alt="playIcon"
                        className="mr10 cursorPointer"
                        style={{ width: 20 }}
                      />

                      {loadingObj.cmvProducts ? (
                          <CircularProgress size={20} />
                        ) : (
                          <span
                            className={cmvProductInfos?.sucessReq && 'bold'}
                            style={{
                              color: cmvProductInfos?.sucessReq  ? '#08AA15' : '#0F1225'
                            }}
                          >
                            {cmvProductInfos?.sucessReq  ? 'OK' : ''}
                          </span>
                        )}
                    </div>
                  </div>
                  
                    <table className="desktop">
                              <thead>
                                <tr className="headerTitle">
                                  <th width="100%" className="subtitle fontSizeDefault">
                                    DESCRIÇÃO
                                  </th>
                                </tr>
                              </thead>
                    
                              <tbody>
                                {cmvProductInfos.sucessReq && cmvProductInfos?.products[0]?.counts?.productsNotInSetup?.length
                                  ? cmvProductInfos?.products[0]?.counts?.productsNotInSetup?.map((product) => (
                                    <>
                                      <tr className="lineBorder">
                                        <td className="description p16 pt0 pb0">
                                          {product?.description}
                                        </td>
                                      </tr>
                    
                                      <tr>
                                        <td colSpan="1" className="m10 textAlignCenter p0">
                                          <hr />
                                        </td>
                                      </tr>
                                    </>
                                  ))
                                : null}
                                
                                {!cmvProductInfos?.products[0]?.counts?.productsNotInSetup?.length ? (
                                  <tr>
                                    <th colSpan="1" className="m10 textAlignCenter">
                                      Não há dados a serem exibidos.
                                    </th>
                                  </tr>
                                ) : null}
                              </tbody>
                            </table>                  
              </div>

              <div className="cardHeader">
                <p>Limpar Vendas</p>
              </div>
              <div className='cardContent'>
                  <div className="dFlex mb10">
                    <div className='dFlex mt10 flexColumn'>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        size="small"
                        id="time-picker"
                        label="Data"
                        ampm={false}
                        // clearable
                        format="dd/MM/yyyy"
                        value={clearSalesDate}
                        inputVariant="outlined"
                        className="dateSmall mt20 mr10"
                        style={{width: '100px'}}
                        placeholder='DD-MM-AAAA'
                        autoOk
                        InputProps={{
                          style: { fontFamily: 'Lato', fontSize: '12px' }
                        }}
                        onChange={(date) => {
                          setClearSalesDate(date)
                        }}
                        KeyboardButtonProps={{
                          'aria-label': 'change time'
                        }}
                      />
                      </MuiPickersUtilsProvider>
                    </div>
                    <div className='dFlex mt10 flexColumn justifyEnd'>
                      <label className='bold mb0' style={{fontSize: '12px'}}>Id do restaurante</label>
                      <TextField
                        size="small"
                        onChange={(e) => setClearSalesId(e.target.value)}
                        variant="outlined"
                        value={clearSalesId}
                        fullWidth
                        required="required"
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(/[^0-9]/g, '');
                        }}
                        inputProps={{ maxLength: 2 }}
                        style={{ width: 70 }}
                        className="textFieldSmall p0"
                        placeholder="Id"
                        InputLabelProps={{
                          shrink: true
                        }}
                      />
                    </div>
                    <div className="dFlex alignEnd" onClick={() => clearSales()}>
                      <img
                        src={PlayIcon}
                        alt="playIcon"
                        className="mr10 cursorPointer"
                        style={{ width: 20 }}
                      />

                      {loadingObj.clearSales ? (
                          <CircularProgress size={20} />
                        ) : (
                          <span
                            className={clearSalesInfos && 'bold'}
                            style={{
                              color: clearSalesInfos ? '#08AA15' : '#0F1225'
                            }}
                          >
                            {clearSalesInfos ? 'OK' : ''}
                          </span>
                        )}
                    </div>
                  </div>
              </div>
          </div>
        </section>

        <Snackbar
          open={!!message.description}
          autoHideDuration={2000}
          onClose={() => setMessage({ description: '', status: '' })}
        >
          <Alert
            onClose={() => setMessage({ description: '', status: '' })}
            severity={message.status}
            color={message.status}
          >
            {message.description}
          </Alert>
        </Snackbar>
      </Container>
    </Layout>
  );
}

const mapStateToProps = (state) => ({
  userInfo: state.user
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(UserActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(BackOffice);
